<template>
  <div class="EditBandLyrics">
    <MainPageHeader v-if="!isAndroidContext"/>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <LoaderLyrics v-if="!lyric.id"
        :title="'Vocale Social'"/>
    <LyricSocialForm
      v-else
      :isAndroidContext="isAndroidContext"
      :lyric="lyric"
      :isEditingMode="isEditingMode"
      :loadingNewPage="loadingNewPage"
      :askPopup="isAskPopup"
      :saving="saving"
      pageTitle="Vocale Social"
      @editLyric="handleEditLyric"
      @handleAskPopup="handleAskPopup"
      @change="handleBandLyricChange"
      @setLoading="setLoading"
    />
    <Footer v-if="!isAndroidContext"/>
  </div>
</template>

<script>
import MainPageHeader from '@/components/MainPageHeader.vue'
import PageNotFound from '@/components/PageNotFound.vue'
import LyricSocialForm from '@/components/lyrics/LyricSocialForm.vue'
import Footer from '@/components/Footer'
import LoaderLyrics from '@/components/lyrics/LoaderLyrics.vue'
import { getAndroidContext } from '@/services/sessionProps'
import { getLyricsService } from '@/services/lyricsService'

export default {
  name: 'ShowSocialLyricPage',
  components: {
    Footer,
    MainPageHeader,
    PageNotFound,
    LyricSocialForm,
    LoaderLyrics,
  },

  props: {
    search: {
      type: Boolean,
      required: false
    }
  },

  data () {
    return {
      loadError: null,
      saving: false,
      isEditingMode: true,
      isAndroidContext: false,
      indexOfLyricElement: null,
      refreshAllLyrics: this.allLyrics,
      refreshId: this.id,
      pageOfLyrics: 1,
      lastPageOfLyricsAPI: 0,
      loadingNewPage: false,
      isAskPopup: false,
      loadingImage: true,
      lyric: {}
    }
  },

  methods: {
    async handleEditLyric(lyric) {
      this.saving = true
      const result = await getLyricsService().editGlobalLyric(lyric)
      this.saving = true
      if(result.status === 201) {
        this.$root.showSnackbar("Piosenka została przesłana", "success")
      } else {
        this.$root.showSnackbar("Nie udało się przesłać piosenki", "error")
      }
      this.$router.push({ name: 'LyricsSocial' })
    },
    setLoading () {
      this.saving = true
    },
    handleBandLyricChange (updatedFields) {
      this.lyric = {
        ...this.lyric,
        ...updatedFields,
      }
    },
    handleAskPopup (state) {
      this.isAskPopup = state
    },
    cutLyricTitle (title) {
      return title.slice(0,22) + '...'
    }
  },

  mounted () {
    window.scrollTo(0,0);
    (async () => {
      this.isAndroidContext = getAndroidContext().isAndroidContext()
      try {
        // if (!this.allLyrics || this.search===true) {
        //   this.refreshAllLyrics = await getLyricsService().getBandLyrics(1)
        //   this.refreshId = parseInt(this.$route.params.id)
        //   this.lastPageOfLyricsAPI = this.refreshAllLyrics.lastPage.page

        //   for (let i = 2; i <= this.lastPageOfLyricsAPI; i++) {
        //     let newLyrics = await getLyricsService().getBandLyrics(i)
        //     newLyrics.bandLyrics.map(lyric => {
        //       this.refreshAllLyrics.bandLyrics.push(lyric)
        //     })

        //     }
        //     this.refreshAllLyrics.bandLyrics.map((lyric, index) => {
        //     if (lyric.id===this.refreshId) {
        //       this.bandLyric = lyric
        //       this.indexOfLyricElement = index
        //     }
        //   })
        // } else {
        //   this.refreshAllLyrics.bandLyrics.map((lyric, index) => {
        //     if (lyric.id===this.id) {
        //       this.bandLyric = lyric
        //       this.indexOfLyricElement = index
        //     }
        //   })
        // }

        // this.getLyricsPagination()
        this.lyric = (await getLyricsService().getOwnLyrics(this.$route.params.id)).data
      } catch (err) {
        this.loadError = `The lyric with the specified id doesn't exist`
      }
    })()
  },
}
</script>

<style lang="scss" scoped>

.EditBandLyrics {
  position: relative;
  padding-bottom: 20px;
  min-height: calc(100vh - 278px);
}

</style>
